"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBaseFontStyles = exports.notoFontFamily = exports.latoFontFamily = exports.NotoFontWeights = exports.FontWeights = void 0;
const buildColorsByBrand_1 = require("./buildColorsByBrand");
var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["Regular"] = 400] = "Regular";
    FontWeights[FontWeights["Bold"] = 700] = "Bold";
    FontWeights[FontWeights["Black"] = 900] = "Black";
})(FontWeights || (exports.FontWeights = FontWeights = {}));
var NotoFontWeights;
(function (NotoFontWeights) {
    NotoFontWeights[NotoFontWeights["Regular"] = 400] = "Regular";
    NotoFontWeights[NotoFontWeights["SemiBold"] = 600] = "SemiBold";
    NotoFontWeights[NotoFontWeights["Bold"] = 700] = "Bold";
})(NotoFontWeights || (exports.NotoFontWeights = NotoFontWeights = {}));
exports.latoFontFamily = [
    'Lato',
    'Noto Sans', // Noto Sans with coverage for Latin, Cyrillic, and Greek character sets. Covers the bulk of our sites languages.
    'Noto Sans SC', // Simplified Chinese for mainland China
    'Noto Sans TC', // Traditional Chinese for Taiwan
    'Noto Sans JP', // Noto Sans for Japanese
    'Noto Sans KR', // Noto Sans for Korea
    '-apple-system', // Targets MacOS default system font. User can change this and OS default has changed over the years.
    '"Helvetica Neue"', // Helvetica version bundled with some OSes. Globally popular among designers, overall proprietary so limited covers.
    '"Segoe UI"', // Default Microsoft systems font
    '"Apple Color Emoji"', // Apple's emoji set
    '"Segoe UI Emoji"', // Microsoft default emoji font set
    '"Segoe UI Symbol"', // Microsoft default font set for special symbols and characters
    'sans-serif', // If none of the above satisfy a character displayed or user doesn't have them installed use whatever san-serif font their system defaults to.
].join(',');
exports.notoFontFamily = [
    'Noto Sans', // Noto Sans with coverage for Latin, Cyrillic, and Greek character sets. Covers the bulk of our sites languages.
    'Noto Sans SC', // Simplified Chinese for mainland China
    'Noto Sans TC', // Traditional Chinese for Taiwan
    'Noto Sans JP', // Noto Sans for Japanese
    'Noto Sans KR', // Noto Sans for Korea
    '-apple-system', // Targets MacOS default system font. User can change this and OS default has changed over the years.
    '"Helvetica Neue"', // Helvetica version bundled with some OSes. Globally popular among designers, overall proprietary so limited covers.
    '"Segoe UI"', // Default Microsoft systems font
    '"Apple Color Emoji"', // Apple's emoji set
    '"Segoe UI Emoji"', // Microsoft default emoji font set
    '"Segoe UI Symbol"', // Microsoft default font set for special symbols and characters
    'sans-serif', // If none of the above satisfy a character displayed or user doesn't have them installed use whatever san-serif font their system defaults to.
].join(',');
const buildBaseFontStyles = (makeNotoPrimaryFont, brandIdentity) => {
    const brandColors = (0, buildColorsByBrand_1.buildColorsByBrand)(brandIdentity);
    const Colors = brandColors.colors;
    return {
        h1: {
            fontSize: '1.75rem', // 28px. 28/16 = 1.75
            fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Bold
                : FontWeights.Black,
            lineHeight: makeNotoPrimaryFont ? 'normal' : 1.2,
            color: Colors.TextPrimary,
            letterSpacing: makeNotoPrimaryFont ? '-0.28px' : '0.42px',
        },
        h2: {
            fontSize: makeNotoPrimaryFont ? '1.375rem' : '1.25rem', // 20px. 20/16 = 1.25
            fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Bold
                : FontWeights.Black,
            lineHeight: makeNotoPrimaryFont ? 'normal' : 1.2,
            textTransform: 'uppercase',
            letterSpacing: makeNotoPrimaryFont ? '-0.22px' : '1.5px',
            color: Colors.TextPrimary,
        },
        h3: Object.assign({ fontSize: '1.125rem', fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Bold
                : FontWeights.Black, lineHeight: makeNotoPrimaryFont ? 'normal' : 1.2, color: Colors.TextPrimary }, (makeNotoPrimaryFont && { letterSpacing: '-0.18x' })),
        h4: Object.assign(Object.assign({ color: Colors.TextPrimary, fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Regular
                : FontWeights.Regular }, (makeNotoPrimaryFont && { lineHeight: 'normal' })), (makeNotoPrimaryFont && { letterSpacing: '-0.16px' })),
        body1: Object.assign({ fontSize: '1rem', lineHeight: makeNotoPrimaryFont ? '24px' : 1.5, fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Regular
                : FontWeights.Regular, color: Colors.TextPrimary }, (makeNotoPrimaryFont && { letterSpacing: '-0.16px' })),
        body2: Object.assign(Object.assign({ fontSize: makeNotoPrimaryFont ? '1rem' : undefined, color: Colors.TextPrimary, fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Regular
                : FontWeights.Regular }, (makeNotoPrimaryFont && { lineHeight: '24px' })), (makeNotoPrimaryFont && { letterSpacing: '-0.16px' })),
        caption: {
            fontSize: '0.75rem', // 12px. 12/16 = 0.75
            fontWeight: makeNotoPrimaryFont
                ? NotoFontWeights.Bold
                : FontWeights.Black,
            color: Colors.TextPrimary,
            lineHeight: makeNotoPrimaryFont ? '16px' : 0.9375,
        },
    };
};
exports.buildBaseFontStyles = buildBaseFontStyles;
//# sourceMappingURL=fonts.js.map